var React = require('react');

function IconPie (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#009EE2;}\n"),React.createElement("path",{"className":"st0","d":"M159,36.8L90,90.3l60.7-62.8C116.1-5.9,60.9-5.1,27.4,29.4C-6.2,64-5.4,119.3,29.2,153s89.9,32.8,123.5-1.8\n\tC183.4,119.6,185.4,70.6,159,36.8z","key":1})]);
}

IconPie.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 180 180","style":{"enableBackground":"new 0 0 180 180"},"xmlSpace":"preserve"};

module.exports = IconPie;

IconPie.default = IconPie;
